import { motion } from "framer-motion";
import { Mail, MapPin } from "lucide-react";
import ContactForm from "@/components/ContactForm";
import { getSection, SOCIALS } from "@/data/siteContent";
import { COLORS } from "@/lib/api";

const Contacto = () => {
  const section = getSection("contacto");
  const accent = COLORS[section.color];

  return (
    <div data-testid="section-contacto">
      <section className="border-b border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <span className="inline-block w-16 h-1.5 rounded-sm mb-6" style={{ background: accent }} />
          <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-tight text-brand-ink">
            Contacto
          </h1>
          <p className="mt-5 text-lg md:text-xl text-brand-ink/70 leading-relaxed max-w-2xl">
            {section.intro}
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-7"
          >
            <ContactForm accent={accent} />
          </motion.div>

          <div className="lg:col-span-5 space-y-6">
            <div className="bg-white border border-[#E5E5E5] rounded-sm p-7">
              <Mail className="text-brand-magenta" size={22} />
              <h3 className="mt-3 font-heading text-xl font-bold text-brand-ink">Escríbenos</h3>
              <p className="mt-1 text-brand-ink/70">
                Cuéntanos cómo quieres sumarte a Juventudes Latentes y te responderemos pronto.
              </p>
            </div>
            <div className="bg-white border border-[#E5E5E5] rounded-sm p-7">
              <MapPin className="text-brand-orange" size={22} />
              <h3 className="mt-3 font-heading text-xl font-bold text-brand-ink">Síguenos</h3>
              <div className="mt-3 flex flex-wrap gap-2">
                {SOCIALS.map((soc) => (
                  <a
                    key={soc.name}
                    href={soc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`contacto-social-${soc.name.toLowerCase()}`}
                    className="border border-[#E5E5E5] text-brand-ink text-sm font-semibold px-3 py-1.5 rounded-sm hover:border-brand-magenta transition-colors"
                  >
                    {soc.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contacto;
